export default __webpack_public_path__ + "static/media/SJA1510.34I-42086_-25233_0.f8f534b4.jpg";